import { Theme } from "@mui/material";
import v1 from "./themes/v1";
import v2 from "./themes/v2";

const themes: Record<string, Theme> = {
  v1,
  v2,
};

const DEFAULT_THEME_VERSION = "v1";
const themeVersion =
  (process.env.REACT_APP_THEME_VERSION as keyof typeof themes) ?? DEFAULT_THEME_VERSION;
const theme = themes[themeVersion];

export default theme;
